import Search from "./component/Search.vue";
import CasesTable from "./component/CasesTable.vue";
import BatchSendModel from "./component/BatchSendModel.vue";
import useApi from "@/api/useApi";

// const list = [];

const tabOptions = [
  { label: "全部", name: "all" },
  { label: "待催收", name: "examine" },
  { label: "跟进中", name: "payment" },
  { label: "待起诉", name: "delivery" },
  { label: "已起诉", name: "received" },
  { label: "已立案", name: "haveInHand" }
];

const baseData = {
  tabOptions,
  activeName: "all",
  /*当前是第几页*/
  curPage: 1,
  /*一页多少条*/
  pageSize: 10,
  /*一共多少条数据*/
  totalDataNumber: 0,
  order_no: "",
  search: "",
  list: []
};

const funcs = {};
funcs.handleClick = function(tab, event) {
  let self = this;
  self.curPage = 1;
  self.pageSize = 10;
  self.getCollectionGetList();
};
funcs.handleUpdate = function(Params) {
  console.log(Params,'Params');
  let self = this;
  self.order_no = Params.order_no;
  self.search = Params.search;
  self.getCollectionGetList();
};

funcs.openModel = function() {
  this.$refs.modelRef.init();
};
funcs.getCollectionGetList = async function() {
  let self = this;
  let Params = {
    dataType: self.activeName,
    order_no: self.order_no,
    search: self.search,
    page: self.curPage,
    list_rows: self.pageSize
  };
  const { data } = await useApi().getCollectionGetList(Params);
  self.list = data.data;
  self.totalDataNumber = data.total;
};
/*选择第几页*/
funcs.handleCurrentChange = function(val) {
  let self = this;
  self.curPage = val;
  self.getCollectionGetList();
};
/*每页多少条*/
funcs.handleSizeChange = function(val) {
  this.curPage = 1;
  this.pageSize = val;
  this.getCollectionGetList();
};
async function dataInit() {
  await this.getCollectionGetList();
}
export default {
  name: "Index",
  props: {},
  components: {
    CasesTable,
    Search,
    BatchSendModel
  },
  data() {
    return { ...baseData };
  },
  methods: { dataInit, ...funcs },
  created: dataInit
};



// WEBPACK FOOTER //
// ./src/views/collection/collection_cases/contact.js